// Utils/Constants
import { DEFAULT_CALC_COLUMNS, EDIT_COLUMNS_INSTRUCTION_TEXT } from 'IndicesApp/ts/apps/indices-app/constants';
import equal from 'NewAngular/utils/equal/deep-equal';
import { INDEX_CALC } from 'CalculationsApp/ts/constants/calc-search-types.constants';
// Services
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { CalculationsService } from 'CalculationsApp/ts/services/calculations.service';
// Components
import { EditDataColumnsModalComponent } from 'NewAngular/features/components/modals/edit-data-columns-modal/edit-data-columns-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "CalculationsApp/ts/services/calculations.service";
export class IndicesEditColumnsModalDirective {
    constructor(accountsService, calculationsService) {
        this.accountsService = accountsService;
        this.calculationsService = calculationsService;
        this.MAX_COLS = 7;
        this.instructionText = EDIT_COLUMNS_INSTRUCTION_TEXT;
        this.loading = false;
        this.modalOpen = false;
        this.modalColumns = [];
        this.modalDefaultColumns = DEFAULT_CALC_COLUMNS;
        this.preferenceCalcsBaseNames = [];
        this.preferenceName = '';
        this.searchType = INDEX_CALC;
        this.mapStateToComponent = (state) => {
            const prevCalcs = this.preferenceCalcsBaseNames;
            const newCalcs = state.preferenceIndicesCalcs;
            if (!equal(prevCalcs, newCalcs)) {
                this.preferenceCalcsBaseNames = newCalcs;
                this.calculationsService.getCalcInfo(state.preferenceIndicesCalcs).subscribe((data) => {
                    this.modalColumns = this.createDataColumns(data);
                });
            }
        };
    }
    ngOnInit() {
        this.loading = true;
        this.accountsService.getUserPreferences().subscribe({
            next: (preference) => {
                // @ts-ignore
                this.updateState(preference[this.preferenceName]);
                this.loading = false;
            },
            error: () => {
                this.loading = false;
            },
        });
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    openModal() {
        this.editDataColumnsModalComponent.openModal();
    }
    submitModal(calcDataColumns) {
        const calcBaseNames = calcDataColumns.map((column) => column.metricInternalName).slice(0, this.MAX_COLS);
        // if new calcs are different than the one in state, update calc preferences
        if (!equal(calcBaseNames, this.preferenceCalcsBaseNames)) {
            const putParams = {};
            putParams[this.preferenceName] = calcBaseNames;
            this.accountsService.putUserPreferences(putParams).subscribe(() => {
                this.updateState(calcBaseNames);
            });
        }
    }
    createDataColumns(calcInfo) {
        const calcBaseNames = Object.keys(calcInfo);
        const calcDataColumns = calcBaseNames.map((baseName) => {
            return {
                metricDisplayValue: calcInfo[baseName].label,
                metricInternalName: baseName,
                columnType: 'metric',
            };
        });
        return calcDataColumns;
    }
}
IndicesEditColumnsModalDirective.ɵfac = function IndicesEditColumnsModalDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IndicesEditColumnsModalDirective)(i0.ɵɵdirectiveInject(i1.AccountsService), i0.ɵɵdirectiveInject(i2.CalculationsService)); };
IndicesEditColumnsModalDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: IndicesEditColumnsModalDirective, viewQuery: function IndicesEditColumnsModalDirective_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(EditDataColumnsModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.editDataColumnsModalComponent = _t.first);
    } } });
